import { defineMessages } from 'react-intl';

/** The copy of the bio tool (design artist-profile c1, d3). */
export const profileBioMessages = defineMessages({
  name: { id: 'app.sml.promote.profile.bio.name', defaultMessage: 'Bio' },
  sub: { id: 'app.sml.promote.profile.bio.sub', defaultMessage: 'The words that go with your pictures · free' },
  writeTitle: { id: 'app.sml.promote.profile.bio.write.title', defaultMessage: 'Write it for me' },
  writeBody: {
    id: 'app.sml.promote.profile.bio.write.body',
    defaultMessage:
      'We write a draft from your songs, genres and the facts below. You keep it, change it or drop it. Nothing is saved before you save.',
  },
  writeDraft: { id: 'app.sml.promote.profile.bio.write.draft', defaultMessage: 'Write a draft' },
  writeDraftNarrow: { id: 'app.sml.promote.profile.bio.write.draftNarrow', defaultMessage: 'Write a draft for me' },
  writing: { id: 'app.sml.promote.profile.bio.write.busy', defaultMessage: 'Writing…' },
  factsTitle: { id: 'app.sml.promote.profile.bio.facts.title', defaultMessage: 'Facts to use' },
  factsHint: {
    id: 'app.sml.promote.profile.bio.facts.hint',
    defaultMessage: 'Optional. A city, a story, a big moment. We never invent streams, press or awards.',
  },
  shortTitle: { id: 'app.sml.promote.profile.bio.short.title', defaultMessage: 'Short bio' },
  shortHint: { id: 'app.sml.promote.profile.bio.short.hint', defaultMessage: 'X, Instagram, TikTok, pitches' },
  shortPlaceholder: {
    id: 'app.sml.promote.profile.bio.short.placeholder',
    defaultMessage: 'One line about you and your music.',
  },
  longTitle: { id: 'app.sml.promote.profile.bio.long.title', defaultMessage: 'Long bio' },
  longHint: { id: 'app.sml.promote.profile.bio.long.hint', defaultMessage: 'Spotify, Apple Music, stores, press' },
  longPlaceholder: {
    id: 'app.sml.promote.profile.bio.long.placeholder',
    defaultMessage: 'Who you are, what your music sounds like, what you did. Spotify shows up to 1500 characters.',
  },
  counter: { id: 'app.sml.promote.profile.bio.counter', defaultMessage: '{count, number} / {max, number}' },
  aiDraft: { id: 'app.sml.promote.profile.bio.aiDraft', defaultMessage: 'AI draft' },
  keep: { id: 'app.sml.promote.profile.bio.keep', defaultMessage: 'Keep' },
  discard: { id: 'app.sml.promote.profile.bio.discard', defaultMessage: 'Discard' },
  copy: { id: 'app.sml.promote.profile.bio.copy', defaultMessage: 'Copy' },
  copied: { id: 'app.sml.promote.profile.bio.copied', defaultMessage: 'Copied' },
  shortTooLong: {
    id: 'app.sml.promote.profile.bio.short.tooLong',
    defaultMessage:
      'The short bio is {count, plural, one {# character} other {# characters}} too long (160). Cut it before you save.',
  },
  longTooLong: {
    id: 'app.sml.promote.profile.bio.long.tooLong',
    defaultMessage:
      'The long bio is {count, plural, one {# character} other {# characters}} too long for Spotify (1500). Cut it before you save.',
  },
  save: { id: 'app.sml.promote.profile.bio.save', defaultMessage: 'Save' },
  saving: { id: 'app.sml.promote.profile.bio.saving', defaultMessage: 'Saving…' },
  cancel: { id: 'app.sml.promote.profile.bio.cancel', defaultMessage: 'Cancel' },
  savedBy: { id: 'app.sml.promote.profile.bio.savedBy', defaultMessage: 'Saved {date} by {name}' },
  savedAt: { id: 'app.sml.promote.profile.bio.savedAt', defaultMessage: 'Saved {date}' },
  savedNow: { id: 'app.sml.promote.profile.bio.savedNow', defaultMessage: 'Saved.' },
  whereTitle: { id: 'app.sml.promote.profile.bio.where.title', defaultMessage: 'Where it goes' },
  whereSpotify: { id: 'app.sml.promote.profile.bio.where.spotify', defaultMessage: 'Spotify' },
  whereSpotify1: {
    id: 'app.sml.promote.profile.bio.where.spotify1',
    defaultMessage: 'Open Spotify for Artists and pick {artist}.',
  },
  whereSpotify2: {
    id: 'app.sml.promote.profile.bio.where.spotify2',
    defaultMessage: 'Profile, then Biography, then Edit.',
  },
  whereSpotify3: { id: 'app.sml.promote.profile.bio.where.spotify3', defaultMessage: 'Paste the long bio. Save.' },
  whereSocial: { id: 'app.sml.promote.profile.bio.where.social', defaultMessage: 'Instagram, TikTok, X' },
  whereSocialBody: {
    id: 'app.sml.promote.profile.bio.where.socialBody',
    defaultMessage: 'Paste the short bio in your profile. 160 characters fit everywhere.',
  },
  wherePress: { id: 'app.sml.promote.profile.bio.where.press', defaultMessage: 'Press and pitches' },
  wherePressBody: {
    id: 'app.sml.promote.profile.bio.where.pressBody',
    defaultMessage: 'The press kit zip (Download all) has bio.txt with both bios. Pitch writing reads the long bio.',
  },
  whereNote: {
    id: 'app.sml.promote.profile.bio.where.note',
    defaultMessage: 'Spotify takes the bio only in Spotify for Artists; MUSIC24 does not send it.',
  },
  aiBudget: {
    id: 'app.sml.promote.profile.bio.error.aiBudget',
    defaultMessage: 'The free AI budget of this month is spent. Upgrade, or write the bio yourself.',
  },
  draftLimit: {
    id: 'app.sml.promote.profile.bio.error.draftLimit',
    defaultMessage: 'You wrote 20 drafts today. Try again tomorrow, or write the bio yourself.',
  },
  leaveTitle: { id: 'app.sml.promote.profile.bio.leave.title', defaultMessage: 'Leave without saving the bio?' },
  leaveBody: {
    id: 'app.sml.promote.profile.bio.leave.body',
    defaultMessage: 'Your changes to the bio are not saved. Leave drops them.',
  },
});
